import React, { useState, useEffect } from 'react'
import PageHeader from '../../Components/PageHeader/PageHeader'
import AppInput from '../../Components/AppInput/AppInput';
import { useSelector, useDispatch } from 'react-redux';
import { Loader2 } from 'lucide-react';
import { getCategoryDisplayName } from '../../utils';
import { Button } from 'rizzui';
import { setRolesAndPermission } from '../../Redux/Actions/RoleAction';
import AppButton from '../../Components/AppButton/AppButton';
import toast from 'react-hot-toast';
import { ApiHit } from '../../Api/ApiHit';
import { addRole, updateRole } from '../../Constant/Constant';
import { setApiErrorJson } from '../../Redux/Actions/ApiAction';
import { useNavigate } from 'react-router-dom';

function AddRole({ isEditMode, roleId, roleData }) {
    const dispatch = useDispatch();
    const ApiReducer = useSelector((state) => state.ApiReducer);
    const RoleReducer = useSelector((state) => state.RolesAndPermissionReducer);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const [selectedPermissions, setSelectedPermissions] = useState({});

    // Initialize selectedPermissions from loaded permissions in edit mode
    useEffect(() => {
        if (isEditMode && RoleReducer?.doc) {
            const initialPermissions = {};

            RoleReducer.doc.forEach((item) => {
                const categoryValue = item.value;

                // Process parent permissions
                if (item.permission?.length > 0) {
                    const perm = item.permission[0];

                    if (perm.read?.allowed) {
                        initialPermissions[`${categoryValue}_read`] = true;
                    }
                    if (perm.write?.allowed) {
                        initialPermissions[`${categoryValue}_write`] = true;
                    }
                    if (perm.delete?.allowed) {
                        initialPermissions[`${categoryValue}_delete`] = true;
                    }
                }

                // Process child permissions
                item.child?.forEach((childItem, childIndex) => {
                    if (childItem.permission?.length > 0) {
                        const childPerm = childItem.permission[0];

                        if (childPerm.read?.allowed) {
                            initialPermissions[`${categoryValue}_${childIndex}_read`] = true;
                        }
                        if (childPerm.write?.allowed) {
                            initialPermissions[`${categoryValue}_${childIndex}_write`] = true;
                        }
                        if (childPerm.delete?.allowed) {
                            initialPermissions[`${categoryValue}_${childIndex}_delete`] = true;
                        }
                    }
                });
            });

            setSelectedPermissions(initialPermissions);
        }
    }, [isEditMode, RoleReducer?.timestamp]);

    console.log("RoleReducer", RoleReducer);

    // Permission handler functions
    const handlePermissionToggle = (categoryValue, permissionType, index, childIndex = null) => {
        // Disable permission toggle during submission
        if (isSubmitting) return;

        const key = childIndex !== null ? `${categoryValue}_${childIndex}_${permissionType}` : `${categoryValue}_${permissionType}`;

        const newSelectedPermissions = { ...selectedPermissions, [key]: !selectedPermissions[key] };
        setSelectedPermissions(newSelectedPermissions);

        const json = RoleReducer?.doc?.map((item, itemIndex) => {
            if (itemIndex === index) {
                const updatedItem = {
                    ...item,
                    permission: item.permission?.map(perm => ({
                        ...perm,
                        read: { ...perm.read },
                        write: { ...perm.write },
                        delete: perm.delete ? { ...perm.delete } : perm.delete
                    })),
                    child: item.child?.map(childItem => ({
                        ...childItem,
                        permission: childItem.permission?.map(perm => ({
                            ...perm,
                            read: { ...perm.read },
                            write: { ...perm.write },
                            delete: perm.delete ? { ...perm.delete } : perm.delete
                        }))
                    }))
                };
                return updatedItem;
            }
            return item;
        });

        const indexedDoc = json?.[index];

        // Handle child permissions
        if (childIndex !== null && indexedDoc?.child?.[childIndex]?.permission?.[0]) {
            const parentPermission = indexedDoc.permission?.[0];
            const childPermission = indexedDoc.child[childIndex].permission[0];
            const currentPerms = childPermission[permissionType];

            if (currentPerms) {
                switch (permissionType) {
                    case 'read':
                        if (parentPermission?.read?.allowed) {
                            currentPerms.allowed = !currentPerms.allowed;
                            if (!currentPerms.allowed) {
                                if (childPermission.write) childPermission.write.allowed = false;
                                if (childPermission.delete) childPermission.delete.allowed = false;
                                newSelectedPermissions[`${categoryValue}_${childIndex}_write`] = false;
                                newSelectedPermissions[`${categoryValue}_${childIndex}_delete`] = false;
                                setSelectedPermissions(newSelectedPermissions);
                            }
                        } else return;
                        break;
                    case 'write':
                        if (parentPermission?.write?.allowed && childPermission?.read?.allowed) {
                            currentPerms.allowed = !currentPerms.allowed;
                            if (!currentPerms.allowed) {
                                if (childPermission.delete) childPermission.delete.allowed = false;
                                newSelectedPermissions[`${categoryValue}_${childIndex}_delete`] = false;
                                setSelectedPermissions(newSelectedPermissions);
                            }
                        } else return;
                        break;
                    case 'delete':
                        if (parentPermission?.delete?.allowed && childPermission?.read?.allowed && childPermission?.write?.allowed) {
                            currentPerms.allowed = !currentPerms.allowed;
                        } else return;
                        break;
                    default:
                        break;
                }
            }
        }
        // Handle parent permissions
        else if (childIndex === null && indexedDoc?.permission?.[0]) {
            const permission = indexedDoc.permission[0];
            const currentPerms = permission[permissionType];

            if (currentPerms) {
                switch (permissionType) {
                    case 'read':
                        currentPerms.allowed = !currentPerms.allowed;
                        if (!currentPerms.allowed) {
                            if (permission.write) permission.write.allowed = false;
                            if (permission.delete) permission.delete.allowed = false;

                            indexedDoc.child?.forEach((childItem, cIndex) => {
                                if (childItem.permission?.[0]) {
                                    const childPerm = childItem.permission[0];
                                    childPerm.read.allowed = false;
                                    if (childPerm.write) childPerm.write.allowed = false;
                                    if (childPerm.delete) childPerm.delete.allowed = false;

                                    newSelectedPermissions[`${categoryValue}_${cIndex}_read`] = false;
                                    newSelectedPermissions[`${categoryValue}_${cIndex}_write`] = false;
                                    newSelectedPermissions[`${categoryValue}_${cIndex}_delete`] = false;
                                }
                            });

                            newSelectedPermissions[`${categoryValue}_write`] = false;
                            newSelectedPermissions[`${categoryValue}_delete`] = false;
                            setSelectedPermissions(newSelectedPermissions);
                        }
                        break;
                    case 'write':
                        if (permission?.read?.allowed) {
                            currentPerms.allowed = !currentPerms.allowed;
                            if (!currentPerms.allowed) {
                                if (permission.delete) permission.delete.allowed = false;

                                indexedDoc.child?.forEach((childItem, cIndex) => {
                                    if (childItem.permission?.[0]) {
                                        const childPerm = childItem.permission[0];
                                        if (childPerm.write) childPerm.write.allowed = false;
                                        if (childPerm.delete) childPerm.delete.allowed = false;

                                        newSelectedPermissions[`${categoryValue}_${cIndex}_write`] = false;
                                        newSelectedPermissions[`${categoryValue}_${cIndex}_delete`] = false;
                                    }
                                });

                                newSelectedPermissions[`${categoryValue}_delete`] = false;
                                setSelectedPermissions(newSelectedPermissions);
                            }
                        } else return;
                        break;
                    case 'delete':
                        if (permission?.read?.allowed && permission?.write?.allowed) {
                            currentPerms.allowed = !currentPerms.allowed;
                            if (!currentPerms.allowed) {
                                indexedDoc.child?.forEach((childItem, cIndex) => {
                                    if (childItem.permission?.[0]?.delete) {
                                        childItem.permission[0].delete.allowed = false;
                                        newSelectedPermissions[`${categoryValue}_${cIndex}_delete`] = false;
                                    }
                                });
                                setSelectedPermissions(newSelectedPermissions);
                            }
                        } else return;
                        break;
                    default:
                        break;
                }
            }
        }

        dispatch(setRolesAndPermission(json));
    };

    const getButtonProps = (categoryValue, permissionType, originalAllowed, index, childIndex = null) => {
        const key = childIndex !== null ? `${categoryValue}_${childIndex}_${permissionType}` : `${categoryValue}_${permissionType}`;
        const isSelected = selectedPermissions[key];

        const readKey = childIndex !== null ? `${categoryValue}_${childIndex}_read` : `${categoryValue}_read`;
        const writeKey = childIndex !== null ? `${categoryValue}_${childIndex}_write` : `${categoryValue}_write`;

        const isReadSelected = selectedPermissions[readKey];
        const isWriteSelected = selectedPermissions[writeKey];

        let isDisabled = false;

        if (childIndex !== null) {
            const parentReadKey = `${categoryValue}_read`;
            const parentWriteKey = `${categoryValue}_write`;
            const parentDeleteKey = `${categoryValue}_delete`;

            const isParentReadSelected = selectedPermissions[parentReadKey];
            const isParentWriteSelected = selectedPermissions[parentWriteKey];
            const isParentDeleteSelected = selectedPermissions[parentDeleteKey];

            if (permissionType === 'read' && !isParentReadSelected) isDisabled = true;
            if (permissionType === 'write' && (!isParentWriteSelected || !isReadSelected)) isDisabled = true;
            if (permissionType === 'delete' && (!isParentDeleteSelected || !isReadSelected || !isWriteSelected)) isDisabled = true;
        } else {
            if (permissionType === 'write' && !isReadSelected) isDisabled = true;
            if (permissionType === 'delete' && (!isReadSelected || !isWriteSelected)) isDisabled = true;
        }

        const baseClasses = isDisabled
            ? 'opacity-50 cursor-not-allowed bg-gray-100 text-gray-400 border-gray-200 px-3 py-1.5 sm:px-4 sm:py-2 font-medium'
            : 'px-3 py-1.5 sm:px-4 sm:py-2 font-medium transition-all duration-200 active:scale-95';

        if (isDisabled) return { className: baseClasses, variant: 'outline', disabled: true };

        const colors = {
            read: isSelected ? 'bg-amber-500 hover:bg-amber-600 text-white border-amber-500 shadow-sm' : originalAllowed ? 'bg-amber-50 hover:bg-amber-100 text-amber-700 border-amber-200' : '',
            write: isSelected ? 'bg-emerald-500 hover:bg-emerald-600 text-white border-emerald-500 shadow-sm' : originalAllowed ? 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border-emerald-200' : '',
            delete: isSelected ? 'bg-rose-500 hover:bg-rose-600 text-white border-rose-500 shadow-sm' : originalAllowed ? 'bg-rose-50 hover:bg-rose-100 text-rose-700 border-rose-200' : ''
        };

        return {
            className: `${baseClasses} ${colors[permissionType] || 'bg-gray-50 hover:bg-gray-100 text-gray-600 border-gray-200'}`,
            variant: isSelected ? 'solid' : 'outline'
        };
    };

    const renderPermissionButtons = (perm, categoryValue, index, childIndex = null) => {
        const availableTypes = ['read', 'write', 'delete'];

        return (
            <div className='flex flex-wrap gap-2 sm:gap-3'>
                {availableTypes.map(type => (
                    <Button
                        key={type}
                        onClick={() => handlePermissionToggle(categoryValue, type, index, childIndex)}
                        size="sm"
                        {...getButtonProps(categoryValue, type, perm[type]?.allowed, index, childIndex)}
                    >
                        <span className='flex items-center space-x-1.5 sm:space-x-2'>
                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {type === 'read' && <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></>}
                                {type === 'write' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />}
                                {type === 'delete' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />}
                            </svg>
                            <span className="text-xs sm:text-sm">{type.charAt(0).toUpperCase() + type.slice(1)}</span>
                        </span>
                    </Button>
                ))}
            </div>
        );
    };

    // Helper function to check if any permissions are selected
    const hasSelectedPermissions = () => {
        return Object.values(selectedPermissions).some(value => value === true);
    };

    // Helper function to construct final JSON for submission
    const constructFinalJson = async (permissionsData) => {
        return new Promise((resolve) => {
            const allowedEndPoints = [];
            const permission = [];

            permissionsData?.forEach(item => {
                const permissionItem = { value: item.value, permission: [], child: [] };
                let hasAnyPermission = false;

                // Process parent permissions
                if (item.permission?.length > 0) {
                    item.permission.forEach(perm => {
                        if (perm.read?.allowed && perm.read?.url) allowedEndPoints.push(...perm.read.url);
                        if (perm.write?.allowed && perm.write?.url) allowedEndPoints.push(...perm.write.url);
                        if (perm.delete?.allowed && perm.delete?.url) allowedEndPoints.push(...perm.delete.url);

                        const permObj = {
                            read: perm.read?.allowed || false,
                            write: perm.write?.allowed || false,
                            delete: perm.delete?.allowed || false
                        };

                        // Check if any permission is true
                        if (permObj.read || permObj.write || permObj.delete) {
                            hasAnyPermission = true;
                        }

                        permissionItem.permission.push(permObj);
                    });
                }

                // Process child permissions
                if (item.child?.length > 0) {
                    item.child.forEach(childItem => {
                        const childPermissionItem = { value: childItem.value, permission: [] };
                        let childHasPermission = false;

                        if (childItem.permission?.length > 0) {
                            childItem.permission.forEach(childPerm => {
                                if (childPerm.read?.allowed && childPerm.read?.url) allowedEndPoints.push(...childPerm.read.url);
                                if (childPerm.write?.allowed && childPerm.write?.url) allowedEndPoints.push(...childPerm.write.url);
                                if (childPerm.delete?.allowed && childPerm.delete?.url) allowedEndPoints.push(...childPerm.delete.url);

                                const childPermObj = {
                                    read: childPerm.read?.allowed || false,
                                    write: childPerm.write?.allowed || false,
                                    delete: childPerm.delete?.allowed || false
                                };

                                // Check if any child permission is true
                                if (childPermObj.read || childPermObj.write || childPermObj.delete) {
                                    childHasPermission = true;
                                    hasAnyPermission = true;
                                }

                                childPermissionItem.permission.push(childPermObj);
                            });
                        }

                        // Only add child if it has at least one true permission
                        if (childHasPermission) {
                            permissionItem.child.push(childPermissionItem);
                        }
                    });
                }

                // Only add permission item if it has at least one true permission
                if (hasAnyPermission) {
                    permission.push(permissionItem);
                }
            });

            resolve({
                allowedEndPoints: [...new Set(allowedEndPoints)],
                permission: permission
            });
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate role name
        if (!ApiReducer?.apiJson?.role || !ApiReducer?.apiJson?.role.trim()) {
            toast.error('Please enter a role name');
            dispatch(setApiErrorJson({ role: 'Role name is required' }));
            return;
        }

        // Check if at least one permission is selected
        if (!hasSelectedPermissions()) {
            toast.error('Please select at least one permission');
            return;
        }

        setIsSubmitting(true);

        try {
            // Construct the final JSON with permissions
            const finalJson = await constructFinalJson(RoleReducer?.doc);

            // Prepare the data for API call
            const formData = {
                roleName: ApiReducer?.apiJson?.role,
                allowedEndPoints: finalJson.allowedEndPoints || [],
                permission: finalJson.permission || [],
                status: "active"
            };

            // Add _id for edit mode
            if (isEditMode && ApiReducer?.apiJson?._id) {
                formData._id = ApiReducer?.apiJson?._id;
            }

            console.log('Submitting role data:', formData);

            // Choose API endpoint based on edit mode
            const apiEndpoint = isEditMode ? updateRole : addRole;

            // Make API call
            ApiHit(formData, apiEndpoint).then((res) => {
                console.log("API response:", res);

                // Check success based on status code
                const successCode = isEditMode ? 200 : 201;

                if (res?.statusCode === successCode) {
                    toast.success(isEditMode ? 'Role updated successfully!' : 'Role created successfully!');
                    // Clear API errors
                    dispatch(setApiErrorJson({}));
                    navigate('/role');
                } else {
                    toast.error(res?.error || res?.message || 'Something went wrong');
                }

                setIsSubmitting(false);
            }).catch((error) => {
                console.error('API error:', error);
                toast.error('Failed to submit role. Please try again.');
                setIsSubmitting(false);
            });

        } catch (error) {
            console.error('Error submitting role:', error);
            toast.error('Failed to submit role. Please try again.');
            setIsSubmitting(false);
        }
    };
    return (
        <div>
            <PageHeader
                title={isEditMode ? 'Edit Role' : 'Add Role'}
                description={
                    isEditMode
                        ? 'Update existing role details and permissions'
                        : 'Create a new role and define its access permissions'
                }
            />

            <div className='bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-6 mt-4 sm:mt-6'>
                <div className='w-full'>
                    <AppInput
                        title="Role Name"
                        placeholder="Type role name here"
                        name="role"
                        error={!ApiReducer?.apiJson?.role}
                    />
                </div>
            </div>

            <div className='mt-6 sm:mt-8'>
                <div className='flex items-start sm:items-center justify-between mb-4 sm:mb-6'>
                    <div className='flex items-start sm:items-center space-x-2 sm:space-x-3'>
                        <div className='w-8 h-8 sm:w-10 sm:h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0'>
                            <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                        </div>
                        <div>
                            <h2 className='text-lg sm:text-xl font-bold text-gray-900'>Access Permissions</h2>
                            <p className='text-xs sm:text-sm text-gray-600'>Configure what this role can access and modify</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='space-y-3 sm:space-y-2'>
                {RoleReducer?.doc?.map((item, index) => {
                    // // Check if user has any permissions for this category
                    // const hasAnyPermission = getAvailablePermissionTypes(item.value).length > 0;

                    // const hasAnyChildPermission = item.child?.some(child =>
                    //     getAvailablePermissionTypes(item.value, item.child.indexOf(child)).length > 0
                    // );

                    // // If user doesn't have any permission for this category and its children, don't show it
                    // if (!hasAnyPermission && !hasAnyChildPermission) {
                    //     return null;
                    // }

                    return (
                        <div key={index} className={`bg-white rounded-xl border-gray-200 border hover:shadow-md transition-shadow duration-200 ${isSubmitting ? 'opacity-75' : ''}`}>
                            <div className='p-4 sm:p-6'>
                                <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4'>
                                    <div className='flex items-center space-x-2 sm:space-x-3'>
                                        <div className='w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center flex-shrink-0'>
                                            <span className='text-white font-bold text-sm sm:text-base'>
                                                {getCategoryDisplayName(item.value).charAt(0)}
                                            </span>
                                        </div>
                                        <div>
                                            <h3 className='text-base sm:text-lg font-semibold text-gray-900'>
                                                {getCategoryDisplayName(item.value)}
                                            </h3>
                                            <p className='text-xs sm:text-sm text-gray-500'>
                                                Manage {getCategoryDisplayName(item.value).toLowerCase()} permissions
                                            </p>
                                        </div>
                                    </div>

                                    {item.permission?.length > 0 && (
                                        <div className='w-full sm:w-auto'>
                                            {item.permission.map((perm, permIndex) => (
                                                <div key={permIndex}>
                                                    {renderPermissionButtons(perm, item.value, index)}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* {item.child?.length > 0 && (
                    <div className='border-t border-gray-100'>
                      {item.child.map((childItem, childIndex) => {
                        // Check if user has any permissions for this child
                        const hasChildPermission = getAvailablePermissionTypes(item.value, childIndex).length > 0;

                        // If no permissions, don't show this child
                        if (!hasChildPermission) {
                          return null;
                        }

                        return (
                          <div key={childIndex} className='p-6 border-b border-gray-50 last:border-b-0'>
                            <div className='flex items-center justify-between'>
                              <div className='flex items-center space-x-3 ml-8'>
                                <div className='w-8 h-8 bg-gradient-to-br from-gray-400 to-gray-600 rounded-lg flex items-center justify-center'>
                                  <span className='text-white font-bold text-xs'>
                                    {getCategoryDisplayName(childItem.value).charAt(0)}
                                  </span>
                                </div>
                                <div>
                                  <h4 className='text-md font-medium text-gray-800'>
                                    {getCategoryDisplayName(childItem.value)}
                                  </h4>
                                  <p className='text-xs text-gray-500'>
                                    Manage {getCategoryDisplayName(childItem.value).toLowerCase()} permissions
                                  </p>
                                </div>
                              </div>

                              {childItem.permission?.length > 0 && (
                                <div className='flex space-x-3'>
                                  {childItem.permission.map((childPerm, childPermIndex) => (
                                    <div key={childPermIndex}>
                                      {renderPermissionButtons(childPerm, item.value, index, childIndex)}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )} */}
                        </div>
                    );
                })}
            </div>

            {/* Submit Button */}
            <div className='mt-6 flex justify-end'>
                <AppButton
                    buttontext={isSubmitting ? (
                        <span className='flex items-center space-x-2'>
                            <Loader2 size={16} className='animate-spin' />
                            <span>Processing...</span>
                        </span>
                    ) : (isEditMode ? 'Update Role' : 'Create Role')}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className='w-full sm:w-auto sm:min-w-[150px]'
                />
            </div>
        </div>

    )
}

export default AddRole
